export default __webpack_public_path__ + "e70e40e27eed3607ec82579c7c239a9d.svg";